<template>
   <div class="">
        <div id="tab1" class="pdl-16 pdr-16" v-if="type=='BADGE'">
            <div class="h-50"></div>
            <div class="h-37"></div>
            <img src="images/reward/notice-no-seal.svg" alt="" class="mgx-auto no-data-seal">
            <div class="t-color-title t-subtitle3 t-center pdt-43 pdb-8 l-spacing48 font-m">{{$t('1707')}}</div>
            <div class="t-color-content1 t-body3 t-center l-spacing42 font-r">{{$t('1708')}}</div>
        </div>

        <div id="tab2" class="t-color-gray2 ripple-item pdl-16 pdr-16 pdb-34" v-if="type=='AVAILABLE'">
            <div class="h-50"></div>
            <div class="h-37"></div>
            <img src="images/reward/notice-no-seal.svg" alt="" class="mgx-auto no-data-seal">
            <div class="t-color-title t-subtitle3 t-center pdt-43 pdb-8 l-spacing48 font-m">{{$t('3024')}}</div>
            <div class="t-color-content1 t-body3 t-center l-spacing42 font-r">{{$t('3025')}}</div>
        </div>
    </div> 
</template>

<script>
/**
 * 데이터 없음 컴포넌트(no data Components)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
export default {
  props: ["type"],
};
</script>
<style scoped>
.mdc-elevation--z3 {
  border-radius: 4px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.no-data-seal {
  width: 56px;
  height: 67px;
}
</style>
